import { render, staticRenderFns } from "./AddStaffCategoryModal.vue?vue&type=template&id=5e1f028e&"
import script from "./AddStaffCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddStaffCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddStaffCategoryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports